import { Suspense } from "react";
import { NavLink, Outlet } from "react-router";
import { useAuth } from "@/auth/AuthProvider";
import { navRoutes } from "@/routes";
import { SiteHeader } from "./SiteHeader";
import { FullPageSpinner } from "@/components/ui";

export function AdminLayout() {
  const { can } = useAuth();

  // Hide nav items the viewer could not open anyway — the route guard and
  // the API would both reject them.
  const links = navRoutes("admin").filter((r) => !r.permissions || can(r.permissions));

  return (
    <>
      <SiteHeader />
      <div className="admin">
        <aside className="admin__sidebar">
          <p className="admin__section-label">Administration</p>
          <nav className="admin__nav" aria-label="Admin">
            {links.map((route) => (
              <NavLink
                key={route.path}
                to={route.path}
                end={route.path === "/admin"}
                className="nav-link"
                title={route.description}
              >
                {route.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main id="main" className="admin__main">
          <Suspense fallback={<FullPageSpinner />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </>
  );
}
